import UsersApi from '@/frontend/api/user';
import { ElMessage, ElLoading } from 'element-plus';
import handlerErrorRequest from '@/frontend/functions/handlerErrorRequest';
export default {
  name: "RecoveryPasswordPage",

  data() {
    return {
      form: {}
    };
  },

  methods: {
    goBack() {
      window.history.length > 1 ? this.$router.go(-1) : false;
    },

    handlerSubmit() {
      let loader = ElLoading.service({
        lock: false,
        text: 'Загрузка'
      });
      UsersApi.requestPasswordReset(this.form).then(response => {
        if (!response.success) {
          ElMessage.error(response.message);
          return;
        }

        if (response.success) {
          ElMessage({
            'type': 'success',
            'message': response.message
          });
          this.$router.push({
            name: 'main'
          });
        }
      }).catch(handlerErrorRequest).finally(() => loader.close());
    }

  }
};